module.exports = __webpack_public_path__ + "img/1.a03f399b.jpg";